import React from 'react'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import AmountOffUptoPricingInputs from './AmountOffUptoPricingInputs'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'

const DiscountApplicationRulesAmountOffUpto = () => {
  return (
    <div className='flex flex-col gap-3 w-full'>
      <h3 className='text-text-sm-semibold text-zinc-800'>Set Discount</h3>

      <AmountOffUptoPricingInputs />

      <PurchaseConditions />
      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesAmountOffUpto
